// ---------------------------------------------------------------------------
// FormFooter — Save/Cancel buttons at the bottom of the form in create mode.
// Uses `Save template` + Cancel (which navigates back to the list). In
// view/edit modes the form renders no footer: edit-mode Save/Cancel live in
// the detail view's title bar (see EvaluationTemplateDetailView).
// ---------------------------------------------------------------------------

import { Button, Spinner } from '@fluentui/react-components';

import { useStyles } from '../../EvaluationTemplateForm.style.js';

export interface FormFooterProps {
  mode: 'create';
  canSubmit: boolean;
  submitting: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export function FormFooter(props: FormFooterProps) {
  const styles = useStyles();

  return (
    <div className={styles.footer}>
      <Button
        appearance="primary"
        disabled={!props.canSubmit}
        onClick={props.onSubmit}
        icon={props.submitting ? <Spinner size="tiny" /> : undefined}
      >
        Save template
      </Button>
      <Button
        appearance="subtle"
        onClick={props.onCancel}
        disabled={props.submitting}
      >
        Cancel
      </Button>
    </div>
  );
}
